import Axios from '../plugins/axios'

export const createBuilding = function (building) {
    return Axios.post('buildings', building)
}

export const fetchBuildings = function () {
    return Axios.get('buildings?lang=bg')
}

export const fetchBuildingsEntrances = function () {
    return Axios.get('buildings/entrances?lang=bg')
}

export const removeBuilding = function (id) {
    return Axios.delete('buildings/' + id)
}

export const fetchBuilding = function (id) {
    return Axios.get(`buildings/${id}?lang=bg`)
}

export const updateBuilding = function (id, building) {
    return Axios.put(`buildings/${id}`, building)
}